import React, {Fragment} from "react";

const headerStyle = { display:"inline" };
const subheaderStyle = { display:"inline-block", paddingLeft:"5px" };

export default class ViewHeaderComponent extends React.Component {

    render() {
        return <Fragment>
            <h5 style={headerStyle}>{this.props.children}</h5>
            {this.props.subheader && <span style={subheaderStyle}>{
                this.props.subheader
            }</span>}
            {this.props.hr === undefined || this.props.hr === true
                ? <hr/>
                : null
            }
        </Fragment>
    }
}
